// extracted by mini-css-extract-plugin
module.exports = {"profile":"Profile_profile__3T9Bf","overBlock":"Profile_overBlock__3yl2R","infoBlock":"Profile_infoBlock__3hrKC"};